import React, { useContext } from "react"
import styles from "./Chip.module.sass"
import TradeInThemeContext from "../TradeInWizard/contexts/theme"
import { ChoiceValue } from "./carAssemblageTypes"

type ChipProps = {
  label: string
  value: ChoiceValue
  isSelected: boolean
  onSelect: (value: ChoiceValue) => void
  color?: string | null
}

const Chip = ({ label, value, isSelected, onSelect, color }: ChipProps) => {
  const theme = useContext(TradeInThemeContext)

  const chipStyle = {
    ...(isSelected
      ? {
        backgroundColor: theme.color,
        color: theme.textCtaColor || "#fff",
      }
      : {}),
    border: `1px solid ${theme.color}`,
  }

  const chipClass = [
    styles.chip,
    styles.chipFlex,
    color && styles.colorDotContainer,
    isSelected && styles.selected,
  ]
    .filter(Boolean)
    .join(" ")

  return (
    <span
      style={chipStyle}
      className={chipClass}
      onClick={() => onSelect(value)}
      onKeyDown={(event) => {
        if (event.key === " " || event.key === "Enter") {
          onSelect(value)
        }
      }}
      role="button"
      aria-pressed={isSelected}
      tabIndex={0}
    >
      {color && (
        <span className={styles.colorDot} style={{ backgroundColor: color }} />
      )}
      {label}
    </span>
  )
}

export default Chip
